/**
 * Binds theme custom language/currency dropdowns to the T Lab widget DOM.
 * Initializes only for [data-tlab-toolbar-slot][data-tl-custom-mode="true"]; safe to load defer on all pages.
 */
(function () {
  'use strict';

  var bridges = [];

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function countrySwitcherFromRoot(tlRoot) {
    if (!tlRoot) return null;
    var all = tlRoot.querySelectorAll('.tl-switcher:not(.tl-language)');
    var i;
    for (i = 0; i < all.length; i++) {
      if (all[i].querySelector('ul.tl-options')) return all[i];
    }
    return all.length ? all[0] : null;
  }

  function languageSwitcherFromRoot(tlRoot) {
    if (!tlRoot) return null;
    var sw = tlRoot.querySelector('.tl-switcher.tl-language');
    if (sw && sw.querySelector('ul.tl-options')) return sw;
    var all = tlRoot.querySelectorAll('.tl-switcher.tl-language');
    var j;
    for (j = 0; j < all.length; j++) {
      if (all[j].querySelector('ul.tl-options')) return all[j];
    }
    return all.length ? all[0] : null;
  }

  function languageOptionsUl(tlRoot) {
    var sw = languageSwitcherFromRoot(tlRoot);
    var main = sw ? sw.querySelector('ul.tl-options') : null;
    if (main && main.querySelector('li.tl-option')) return main;
    var alt = tlRoot.querySelector('.tl-languages-unwrap ul.tl-options');
    if (alt && alt.querySelector('li.tl-option')) return alt;
    return main || alt;
  }

  function countryOptionsUl(tlRoot) {
    var sw = countrySwitcherFromRoot(tlRoot);
    return sw ? sw.querySelector('ul.tl-options') : null;
  }

  function optionLabelText(li) {
    var name = li.querySelector('.tl-name');
    var lab = name || li.querySelector('.tl-label');
    if (!lab) return '';
    return String(lab.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function readLanguageCurrent(tlRoot) {
    var sw = languageSwitcherFromRoot(tlRoot);
    if (!sw) return '';
    var sel = sw.querySelector('.tl-select .tl-label.tl-name, .tl-select .tl-label');
    if (sel && sel.textContent.trim()) return sel.textContent.replace(/\s+/g, ' ').trim();
    var active = sw.querySelector('li.tl-option.active');
    if (active) return optionLabelText(active);
    return '';
  }

  function readCountryCurrent(tlRoot) {
    var sw = countrySwitcherFromRoot(tlRoot);
    if (!sw) return '';
    var ul = countryOptionsUl(tlRoot);
    var active = ul
      ? ul.querySelector('li.tl-option.active')
      : sw.querySelector('li.tl-option.active');
    if (active) {
      var fromActive = optionLabelText(active);
      if (fromActive) return fromActive;
    }
    var form =
      sw.querySelector('form.shopify-localization-form') ||
      sw.querySelector('form') ||
      (tlRoot && tlRoot.querySelector('form'));
    var hidden = form ? form.querySelector('input[name="country_code"]') : null;
    var code = hidden && hidden.value ? String(hidden.value).trim() : '';
    if (code && ul) {
      var matchLi = findTlOptionByValue(ul, code);
      if (matchLi) {
        var fromMatch = optionLabelText(matchLi);
        if (fromMatch) return fromMatch;
      }
    }
    var sel = sw.querySelector('.tl-select .tl-label');
    if (sel && sel.textContent.trim()) {
      return sel.textContent.replace(/\s+/g, ' ').trim();
    }
    return '';
  }

  /**
   * Country ISO order from theme setting (Custom Localization → Country name),
   * built in Liquid to match `custom_currency_language_selector`.
   */
  function orderTlCountryOptions(opts, orderCsv) {
    if (!orderCsv || !opts || !opts.length) return opts.slice();
    var order = orderCsv.split(',').map(function (s) {
      return String(s || '')
        .trim()
        .toLowerCase();
    }).filter(Boolean);
    if (!order.length) return opts.slice();
    var map = {};
    var i;
    for (i = 0; i < opts.length; i++) {
      var li = opts[i];
      var v = String(li.getAttribute('data-value') || '')
        .trim()
        .toLowerCase();
      if (v) map[v] = li;
    }
    var seen = {};
    var out = [];
    for (i = 0; i < order.length; i++) {
      var code = order[i];
      if (seen[code] || !map[code]) continue;
      seen[code] = true;
      out.push(map[code]);
    }
    for (i = 0; i < opts.length; i++) {
      var vv = String(opts[i].getAttribute('data-value') || '')
        .trim()
        .toLowerCase();
      if (!vv || seen[vv]) continue;
      seen[vv] = true;
      out.push(opts[i]);
    }
    return out;
  }

  function findTlOptionByValue(ul, value) {
    if (!ul || value == null) return null;
    var want = String(value).trim();
    var lis = ul.querySelectorAll('li.tl-option');
    var i;
    for (i = 0; i < lis.length; i++) {
      var v = (lis[i].getAttribute('data-value') || '').trim();
      if (v === want) return lis[i];
    }
    for (i = 0; i < lis.length; i++) {
      var v2 = (lis[i].getAttribute('data-value') || '').trim();
      if (v2.toLowerCase() === want.toLowerCase()) return lis[i];
    }
    return null;
  }

  var RETRY_POLL_MS = 500;
  var RETRY_POLL_MAX_MS = 60000;

  function widgetOptionsReady(tlRoot, slotEl) {
    if (!tlRoot || !slotEl) return false;
    var needsLang = !!slotEl.querySelector('[data-tlab-lang-list]');
    var needsCountry = !!slotEl.querySelector('[data-tlab-country-list]');
    var langUl = languageOptionsUl(tlRoot);
    var countryUl = countryOptionsUl(tlRoot);
    var langOk =
      !needsLang || !!(langUl && langUl.querySelector('li.tl-option'));
    var countryOk =
      !needsCountry || !!(countryUl && countryUl.querySelector('li.tl-option'));
    return langOk && countryOk;
  }

  function listOptionsSignature(ul) {
    if (!ul) return '';
    var lis = ul.querySelectorAll('li.tl-option');
    var out = [];
    var i;
    for (i = 0; i < lis.length; i++) {
      var li = lis[i];
      out.push(
        (li.getAttribute('data-value') || '').trim() +
          ':' +
          (li.classList.contains('active') ? '1' : '0') +
          ':' +
          optionLabelText(li)
      );
    }
    return out.join('|');
  }

  function mirrorStateSignature(tlRoot, slotEl) {
    if (!tlRoot || !slotEl || !widgetOptionsReady(tlRoot, slotEl)) return '';
    var parts = [];
    if (slotEl.querySelector('[data-tlab-lang-list]')) {
      parts.push('L:' + listOptionsSignature(languageOptionsUl(tlRoot)));
    }
    if (slotEl.querySelector('[data-tlab-country-list]')) {
      parts.push('C:' + listOptionsSignature(countryOptionsUl(tlRoot)));
    }
    parts.push('curlang:' + readLanguageCurrent(tlRoot));
    parts.push('curcountry:' + readCountryCurrent(tlRoot));
    return parts.join('#');
  }

  function dispatchPickerClose(pickerId) {
    window.dispatchEvent(
      new CustomEvent('tlab-picker-close', {
        bubbles: true,
        detail: { pickerId: pickerId },
      })
    );
  }

  function TLabSlotBridge(slotEl) {
    this.slotEl = slotEl;
    this.tlRoot = slotEl.querySelector('[id^="tl-custom-widget"]');
    this.mo = null;
    this._retryTimer = null;
    this._lastMirrorSignature = null;
    this._retryStarted = Date.now();
    var self = this;
    this._debounced = debounce(function () {
      self._syncAll();
    }, 80);

    this.disposers = [];
    if (!this.tlRoot) return;
    this._bindDelegates();
    this._startObserver();
    this._retryTimer = window.setInterval(function () {
      if (!document.contains(slotEl)) {
        self._stopRetryPolling();
        return;
      }
      if (Date.now() - self._retryStarted > RETRY_POLL_MAX_MS) {
        self._stopRetryPolling();
        return;
      }
      self._syncAll();
    }, RETRY_POLL_MS);
    this.disposers.push(function () {
      self._stopRetryPolling();
    });

    window.setTimeout(function () {
      if (document.contains(slotEl)) self._syncAll();
    }, 0);
  }

  TLabSlotBridge.prototype._stopRetryPolling = function () {
    if (this._retryTimer) {
      window.clearInterval(this._retryTimer);
      this._retryTimer = null;
    }
  };

  TLabSlotBridge.prototype.dispose = function () {
    if (this.mo) {
      try {
        this.mo.disconnect();
      } catch (_) {}
      this.mo = null;
    }
    while (this.disposers.length) {
      var d = this.disposers.pop();
      try {
        d();
      } catch (_) {}
    }
  };

  TLabSlotBridge.prototype._startObserver = function () {
    var self = this;
    this.mo = new MutationObserver(function () {
      self._debounced();
    });
    try {
      this.mo.observe(this.tlRoot, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
      });
    } catch (_) {}
  };

  TLabSlotBridge.prototype._bindDelegates = function () {
    var self = this;
    var langList = this.slotEl.querySelector('[data-tlab-lang-list]');
    var countryList = this.slotEl.querySelector('[data-tlab-country-list]');

    function onLangClick(e) {
      var btn = e.target.closest('[data-tlab-mirror="language"]');
      if (!btn || !langList || !langList.contains(btn)) return;
      e.preventDefault();
      var ul = languageOptionsUl(self.tlRoot);
      var raw = btn.getAttribute('data-tl-value');
      var li = findTlOptionByValue(ul, raw);
      if (li) li.click();
      var wrap = btn.closest('[data-tlab-dd="language"]');
      var pid = wrap && wrap.getAttribute('data-tlab-picker-id');
      if (pid) dispatchPickerClose(pid);
    }

    function onCountryClick(e) {
      var btn = e.target.closest('[data-tlab-mirror="country"]');
      if (!btn || !countryList || !countryList.contains(btn)) return;
      e.preventDefault();
      var ul = countryOptionsUl(self.tlRoot);
      var raw = btn.getAttribute('data-tl-value');
      var li = findTlOptionByValue(ul, raw);
      if (li) li.click();
      var wrap = btn.closest('[data-tlab-dd="country"]');
      var pid = wrap && wrap.getAttribute('data-tlab-picker-id');
      if (pid) dispatchPickerClose(pid);
    }

    this.slotEl.addEventListener('click', onLangClick);
    this.slotEl.addEventListener('click', onCountryClick);
    this.disposers.push(function () {
      self.slotEl.removeEventListener('click', onLangClick);
      self.slotEl.removeEventListener('click', onCountryClick);
    });
  };

  TLabSlotBridge.prototype._buildMirrorLi = function (kind, tlLi, isFooterSlot) {
    var value = (tlLi.getAttribute('data-value') || '').trim();
    var label = optionLabelText(tlLi);
    var active = tlLi.classList.contains('active');
    var li = document.createElement('li');
    var baseCls =
      'cursor-pointer transition hover:bg-[rgba(var(--colors-text),0.05)]';
    var themeCls =
      isFooterSlot ? ' sticky-footer' : ' options-text-color hover:text-black';
    li.className = baseCls + themeCls;

    var btn = document.createElement('button');
    btn.type = 'button';
    var btnCls =
      'relative w-full text-left py-2 px-4 whitespace-nowrap capitalize' +
      (active ? ' font-bold bg-[rgba(var(--colors-text),0.05)]' : '');
    btn.className = btnCls;
    btn.setAttribute('data-tlab-mirror', kind);
    btn.setAttribute('data-tl-value', value);
    btn.setAttribute('translate', 'no');
    btn.textContent = label || value;
    li.appendChild(btn);
    return li;
  };

  TLabSlotBridge.prototype._footerContext = function () {
    return !!(
      this.slotEl.closest('#section-footer') ||
      this.slotEl.closest('.background-footer')
    );
  };

  TLabSlotBridge.prototype._hydrateLanguages = function () {
    var list = this.slotEl.querySelector('[data-tlab-lang-list]');
    var loader = this.slotEl.querySelector('[data-tlab-lang-loader]');
    var toggle = this.slotEl.querySelector('[data-tlab-lang-toggle]');
    var labelEl = this.slotEl.querySelector('[data-tlab-lang-label]');
    if (!list || !loader) return;

    var ul = languageOptionsUl(this.tlRoot);
    if (!ul || !ul.querySelector('li.tl-option')) return;

    var isFooterSlot = this._footerContext();

    var frag = document.createDocumentFragment();
    var opts = [];
    var ch = ul.children;
    var j;
    for (j = 0; j < ch.length; j++) {
      var elCH = ch[j];
      if (elCH.tagName === 'LI' && elCH.classList.contains('tl-option')) opts.push(elCH);
    }
    if (opts.length === 0) opts = Array.prototype.slice.call(ul.querySelectorAll('li.tl-option'));

    var i;
    for (i = 0; i < opts.length; i++) {
      frag.appendChild(this._buildMirrorLi('language', opts[i], isFooterSlot));
    }
    list.innerHTML = '';
    list.appendChild(frag);
    loader.classList.add('hidden');
    list.classList.remove('hidden');
    if (toggle) toggle.removeAttribute('aria-busy');

    var cur = readLanguageCurrent(this.tlRoot);
    if (!cur && labelEl) {
      var first = ul.querySelector('li.tl-option.active') || ul.querySelector('li.tl-option');
      if (first) cur = optionLabelText(first);
    }
    if (labelEl && cur) labelEl.textContent = cur;
  };

  TLabSlotBridge.prototype._hydrateCountries = function () {
    var list = this.slotEl.querySelector('[data-tlab-country-list]');
    var loader = this.slotEl.querySelector('[data-tlab-country-loader]');
    var toggle = this.slotEl.querySelector('[data-tlab-country-toggle]');
    var labelEl = this.slotEl.querySelector('[data-tlab-country-label]');
    if (!list || !loader) return;

    var ul = countryOptionsUl(this.tlRoot);
    if (!ul || !ul.querySelector('li.tl-option')) return;

    var isFooterSlot = this._footerContext();

    var frag = document.createDocumentFragment();
    var opts = [];
    var ch = ul.children;
    var j;
    for (j = 0; j < ch.length; j++) {
      var elCH = ch[j];
      if (elCH.tagName === 'LI' && elCH.classList.contains('tl-option')) opts.push(elCH);
    }
    if (opts.length === 0) opts = Array.prototype.slice.call(ul.querySelectorAll('li.tl-option'));

    var customRoot = this.slotEl.querySelector('[data-tlab-custom-selectors-root]');
    var orderCsv =
      customRoot && customRoot.getAttribute('data-tlab-country-order');
    opts = orderTlCountryOptions(opts, orderCsv);

    var i;
    for (i = 0; i < opts.length; i++) {
      frag.appendChild(this._buildMirrorLi('country', opts[i], isFooterSlot));
    }
    list.innerHTML = '';
    list.appendChild(frag);
    loader.classList.add('hidden');
    list.classList.remove('hidden');
    if (toggle) toggle.removeAttribute('aria-busy');

    var cur = readCountryCurrent(this.tlRoot);
    if (!cur && labelEl) {
      var first = ul.querySelector('li.tl-option.active') || ul.querySelector('li.tl-option');
      if (first) cur = optionLabelText(first);
    }
    if (labelEl && cur) labelEl.textContent = cur;
  };

  TLabSlotBridge.prototype._syncAll = function () {
    if (!this.tlRoot || !document.body.contains(this.tlRoot)) return;
    var ready = widgetOptionsReady(this.tlRoot, this.slotEl);
    var sig = ready ? mirrorStateSignature(this.tlRoot, this.slotEl) : '';
    if (ready && sig && sig === this._lastMirrorSignature) {
      this._stopRetryPolling();
      return;
    }

    if (this.slotEl.querySelector('[data-tlab-lang-list]')) this._hydrateLanguages();
    if (this.slotEl.querySelector('[data-tlab-country-list]')) this._hydrateCountries();

    if (widgetOptionsReady(this.tlRoot, this.slotEl)) {
      this._lastMirrorSignature = mirrorStateSignature(this.tlRoot, this.slotEl);
      this._stopRetryPolling();
    }
  };

  function initAll() {
    disposeAll();
    var nodes = document.querySelectorAll('[data-tlab-toolbar-slot][data-tl-custom-mode="true"]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      try {
        bridges.push(new TLabSlotBridge(nodes[i]));
      } catch (_) {}
    }
  }

  function disposeAll() {
    while (bridges.length) {
      var b = bridges.pop();
      try {
        b.dispose();
      } catch (_) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
